import { instance } from "libs/api";

import { ApiRoutesFinancialReport } from "../../constants";
import { FinancialSettings } from "../financialReport.types";

export const requestUpdateFinancialSettings = async (
  body: FinancialSettings
): Promise<FinancialSettings> => {
  return await instance.put(ApiRoutesFinancialReport.Settings, body);
};
